import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f8fba55"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "breadcrumb" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "breadcrumb-item current" }, "个股量化", -1))
const _hoisted_4 = { class: "page-header" }
const _hoisted_5 = { class: "scroll-container" }
const _hoisted_6 = { class: "main-content" }
const _hoisted_7 = { class: "step-header" }
const _hoisted_8 = {
  key: 0,
  class: "selected-stock-card"
}
const _hoisted_9 = { class: "selected-stock-info" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("当前已选 ")
const _hoisted_11 = { style: {"font-weight":"800"} }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "ai-btn-wrap" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ai-tooltip-wrap" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ai-question" }, "?"),
  /*#__PURE__*/_createElementVNode("div", { class: "ai-tooltip" }, "遍历所有策略，找出最优组合")
], -1))
const _hoisted_15 = { class: "search-section" }
const _hoisted_16 = { class: "input-field" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 或直接从自选股中选择 ")
const _hoisted_18 = ["src"]
const _hoisted_19 = {
  key: 0,
  class: "stock-cards"
}
const _hoisted_20 = { class: "stock-row" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "stock-info" }
const _hoisted_23 = { class: "stock-price" }
const _hoisted_24 = ["src"]
const _hoisted_25 = {
  key: 1,
  class: "stock-toast"
}
const _hoisted_26 = { class: "step-header" }
const _hoisted_27 = {
  key: 0,
  class: "selected-tag"
}
const _hoisted_28 = ["src"]
const _hoisted_29 = { class: "indicator-cards" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = ["src"]
const _hoisted_32 = {
  key: 0,
  class: "option-popover option-popover--up"
}
const _hoisted_33 = { class: "option-list" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "option-footer" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "option-note" }, "注：买卖规则不可相同", -1))
const _hoisted_37 = ["disabled"]
const _hoisted_38 = { class: "step-header" }
const _hoisted_39 = {
  key: 0,
  class: "selected-tag"
}
const _hoisted_40 = ["src"]
const _hoisted_41 = { class: "indicator-cards" }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = ["src"]
const _hoisted_44 = {
  key: 0,
  class: "option-popover option-popover--up"
}
const _hoisted_45 = { class: "option-list" }
const _hoisted_46 = ["onClick"]
const _hoisted_47 = { class: "option-footer" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "option-note" }, "注：买卖规则不可相同", -1))
const _hoisted_49 = ["disabled"]
const _hoisted_50 = { class: "step-header-inline" }
const _hoisted_51 = { class: "step-info" }
const _hoisted_52 = { class: "period-options" }
const _hoisted_53 = ["onClick"]
const _hoisted_54 = ["onClick"]
const _hoisted_55 = ["src"]
const _hoisted_56 = /*#__PURE__*/_createTextVNode(" 自定义 ")
const _hoisted_57 = ["src"]
const _hoisted_58 = { class: "strategy-summary" }
const _hoisted_59 = { class: "summary-row" }
const _hoisted_60 = { class: "summary-item" }
const _hoisted_61 = /*#__PURE__*/_createTextVNode("股票设定：")
const _hoisted_62 = { class: "summary-item" }
const _hoisted_63 = /*#__PURE__*/_createTextVNode("买入信号：")
const _hoisted_64 = { class: "buy-signal" }
const _hoisted_65 = { class: "summary-item" }
const _hoisted_66 = /*#__PURE__*/_createTextVNode("卖出信号：")
const _hoisted_67 = { class: "sell-signal" }
const _hoisted_68 = { class: "summary-row" }
const _hoisted_69 = { class: "summary-item" }
const _hoisted_70 = /*#__PURE__*/_createTextVNode("回测周期：")
const _hoisted_71 = {
  key: 0,
  class: "global-loading-mask"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StarTabBar = _resolveComponent("StarTabBar")!
  const _component_QuantSelect = _resolveComponent("QuantSelect")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_StarXpGate = _resolveComponent("StarXpGate")!
  const _directive_widthoverflowtitle = _resolveDirective("widthoverflowtitle")!

  return (_openBlock(), _createBlock(_component_StarXpGate, { na: "starStock" }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "star-stock-page",
        style: _normalizeStyle({ background: _ctx.colors.bg })
      }, [
        _createElementVNode("div", {
          class: "tab-bar",
          style: _normalizeStyle({ background: _ctx.colors.bgTabBar })
        }, [
          _createVNode(_component_StarTabBar, {
            modelValue: _ctx.activeTopTab,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeTopTab) = $event))
          }, null, 8, ["modelValue"])
        ], 4),
        _createElementVNode("div", {
          class: "top-header-section",
          style: _normalizeStyle({ background: _ctx.isLight ? '#ffffff' : _ctx.colors.bgPanel })
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("span", {
              class: "breadcrumb-item link",
              style: _normalizeStyle({ color: _ctx.colors.textMuted }),
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goHome && _ctx.goHome(...args)))
            }, "首页", 4),
            _createElementVNode("img", {
              src: _ctx.breadcrumbArrow,
              alt: ">",
              class: "breadcrumb-arrow"
            }, null, 8, _hoisted_2),
            _hoisted_3
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h1", {
              class: "page-title",
              style: _normalizeStyle({ color: _ctx.colors.textPrimary })
            }, "个股量化", 4),
            _createElementVNode("p", {
              class: "page-subtitle",
              style: _normalizeStyle({ color: _ctx.colors.textMuted })
            }, "配置买卖信号，智能把握交易时机", 4)
          ])
        ], 4),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              class: "step-section",
              style: _normalizeStyle({ background: _ctx.isLight ? '#ffffff' : _ctx.colors.bgCard })
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("h2", {
                  class: "step-title",
                  style: _normalizeStyle({ color: _ctx.colors.textPrimary })
                }, "第一步：股票设定", 4),
                (_ctx.selectedStock && _ctx.selectedStock.securityNo)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", {
                          class: "selected-stock-name",
                          style: _normalizeStyle({ color: _ctx.colors.textPrimary })
                        }, [
                          _hoisted_10,
                          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.selectedStock.securityNo) + " " + _toDisplayString(_ctx.selectedStock.securityName), 1)
                        ], 4)
                      ]),
                      _createElementVNode("div", {
                        class: "close-btn selected-close",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleStockSelect({})))
                      }, [
                        _createElementVNode("img", {
                          src: _ctx.closeIcon,
                          alt: "关闭"
                        }, null, 8, _hoisted_12)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("button", {
                    class: "ai-btn",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleAiQuant && _ctx.handleAiQuant(...args)))
                  }, "AI 智能量化"),
                  _hoisted_14
                ])
              ]),
              _createElementVNode("p", {
                class: "step-description",
                style: _normalizeStyle({ color: _ctx.colors.textMuted })
              }, "选择个股后，系统会为您量身定制专属的买卖策略，助您把握最佳交易时机", 4),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_QuantSelect, {
                    theme: _ctx.isDark ? 'dark' : 'light',
                    tags: _ctx.selectedStock,
                    onCheckStock: _ctx.handleStockSelect
                  }, null, 8, ["theme", "tags", "onCheckStock"])
                ]),
                _createElementVNode("span", {
                  class: "optional-toggle",
                  style: _normalizeStyle({ color: _ctx.colors.textPrimary }),
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showOptional = !_ctx.showOptional))
                }, [
                  _hoisted_17,
                  _createElementVNode("img", {
                    src: _ctx.arrowDown,
                    class: _normalizeClass(["toggle-arrow", { open: _ctx.showOptional }]),
                    alt: "▾"
                  }, null, 10, _hoisted_18)
                ], 4)
              ]),
              (_ctx.showOptional)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stockList, (stock) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: stock.securityNo,
                          class: _normalizeClass(["stock-card", { selected: _ctx.selectedStock && _ctx.selectedStock.securityNo === stock.securityNo }]),
                          style: _normalizeStyle(_ctx.selectedStock && _ctx.selectedStock.securityNo === stock.securityNo ? {} : { background: _ctx.isLight ? '#f0f2f5' : _ctx.colors.bgActionBtn }),
                          onClick: ($event: any) => (_ctx.handleStockSelect(stock))
                        }, [
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("div", {
                              class: "stock-name",
                              style: _normalizeStyle(_ctx.selectedStock && _ctx.selectedStock.securityNo === stock.securityNo ? { color: '#000' } : { color: _ctx.colors.textPrimary })
                            }, _toDisplayString(stock.securityNo) + " " + _toDisplayString(stock.securityName), 5),
                            _createElementVNode("div", _hoisted_23, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["price", stock.pxChangeRate > 0 ? 'rise' : stock.pxChangeRate < 0 ? 'fall' : 'neutral'])
                              }, _toDisplayString(stock.optionalPrice), 3),
                              (stock.pxChangeRate != null)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: _normalizeClass(["change", stock.pxChangeRate > 0 ? 'rise' : stock.pxChangeRate < 0 ? 'fall' : 'neutral'])
                                  }, _toDisplayString((stock.pxChangeRate * 100).toFixed(2)) + "%", 3))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          (_ctx.selectedStock && _ctx.selectedStock.securityNo === stock.securityNo)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "close-btn",
                                onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.handleStockSelect({})), ["stop"]))
                              }, [
                                _createElementVNode("img", {
                                  src: _ctx.closeIcon,
                                  alt: "关闭"
                                }, null, 8, _hoisted_24)
                              ]))
                            : _createCommentVNode("", true)
                        ], 14, _hoisted_21))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.showToast)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_ctx.toastMsg), 1))
                : _createCommentVNode("", true)
            ], 4),
            _createElementVNode("div", {
              class: "step-section",
              style: _normalizeStyle({ background: _ctx.isLight ? '#ffffff' : _ctx.colors.bgCard })
            }, [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("h2", {
                  class: "step-title",
                  style: _normalizeStyle({ color: _ctx.colors.textPrimary })
                }, "第二步：买入规则", 4),
                (_ctx.selectedBuy)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      _createElementVNode("span", null, "当前已选：" + _toDisplayString(_ctx.selectedBuy.factorName) + ":" + _toDisplayString(_ctx.selectedBuy.optionName), 1),
                      _createElementVNode("div", {
                        class: "selected-tag-close",
                        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.clearBuy && _ctx.clearBuy(...args)))
                      }, [
                        _createElementVNode("img", {
                          src: _ctx.closeIcon,
                          alt: "删除"
                        }, null, 8, _hoisted_28)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("p", {
                class: "step-description",
                style: _normalizeStyle({ color: _ctx.colors.textMuted })
              }, "选择技术指标及买入信号", 4),
              _createElementVNode("div", _hoisted_29, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buyList, (factor) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: factor.factorCode,
                    class: "indicator-card-wrap"
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["indicator-card 12", { selected: _ctx.selectedBuy && _ctx.selectedBuy.factorCode === factor.factorCode }]),
                      style: _normalizeStyle(_ctx.selectedBuy && _ctx.selectedBuy.factorCode === factor.factorCode ? {} : { background: _ctx.isLight ? '#f0f2f5' : _ctx.colors.bgActionBtn }),
                      onClick: ($event: any) => (_ctx.openBuyPopover(factor))
                    }, [
                      _withDirectives((_openBlock(), _createElementBlock("div", {
                        class: "indicator-name",
                        style: _normalizeStyle(_ctx.selectedBuy && _ctx.selectedBuy.factorCode === factor.factorCode ? { color: '#000' } : { color: _ctx.colors.textPrimary })
                      }, [
                        _createTextVNode(_toDisplayString(factor.factorName), 1)
                      ], 4)), [
                        [_directive_widthoverflowtitle, factor.factorName]
                      ]),
                      _withDirectives((_openBlock(), _createElementBlock("div", {
                        class: "indicator-type",
                        style: _normalizeStyle(_ctx.selectedBuy && _ctx.selectedBuy.factorCode === factor.factorCode ? { color: '#fe4043' } : { color: _ctx.colors.textSecondary })
                      }, [
                        _createTextVNode(_toDisplayString(factor.factorDescript), 1)
                      ], 4)), [
                        [_directive_widthoverflowtitle, factor.factorDescript]
                      ]),
                      (_ctx.selectedBuy && _ctx.selectedBuy.factorCode === factor.factorCode)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "close-btn",
                            onClick: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clearBuy && _ctx.clearBuy(...args)), ["stop"]))
                          }, [
                            _createElementVNode("img", {
                              src: _ctx.closeIcon,
                              alt: "关闭"
                            }, null, 8, _hoisted_31)
                          ]))
                        : _createCommentVNode("", true)
                    ], 14, _hoisted_30),
                    (_ctx.buyPopover === factor.factorCode)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                          _createElementVNode("div", _hoisted_33, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(factor.options, (opt) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: opt.optionCode,
                                class: _normalizeClass(["option-item", { 'option-item--active': _ctx.pendingBuyOption && _ctx.pendingBuyOption.opt.optionCode === opt.optionCode }]),
                                onClick: ($event: any) => (_ctx.pendingBuyOption = { factor, opt })
                              }, _toDisplayString(opt.optionName), 11, _hoisted_34))
                            }), 128))
                          ]),
                          _createElementVNode("div", _hoisted_35, [
                            _hoisted_36,
                            _createElementVNode("button", {
                              class: _normalizeClass(["option-confirm-btn", { 'option-confirm-btn--disabled': !_ctx.pendingBuyOption }]),
                              disabled: !_ctx.pendingBuyOption,
                              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.confirmBuyOption && _ctx.confirmBuyOption(...args)))
                            }, "确定", 10, _hoisted_37)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ], 4),
            _createElementVNode("div", {
              class: "step-section",
              style: _normalizeStyle({ background: _ctx.isLight ? '#ffffff' : _ctx.colors.bgCard })
            }, [
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("h2", {
                  class: "step-title",
                  style: _normalizeStyle({ color: _ctx.colors.textPrimary })
                }, "第三步：卖出规则", 4),
                (_ctx.selectedSell)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                      _createElementVNode("span", null, "当前已选：" + _toDisplayString(_ctx.selectedSell.factorName) + ":" + _toDisplayString(_ctx.selectedSell.optionName), 1),
                      _createElementVNode("div", {
                        class: "selected-tag-close",
                        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.clearSell && _ctx.clearSell(...args)))
                      }, [
                        _createElementVNode("img", {
                          src: _ctx.closeIcon,
                          alt: "删除"
                        }, null, 8, _hoisted_40)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("p", {
                class: "step-description",
                style: _normalizeStyle({ color: _ctx.colors.textMuted })
              }, "选择技术指标及卖出信号", 4),
              _createElementVNode("div", _hoisted_41, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.factorList, (factor) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: factor.factorCode,
                    class: "indicator-card-wrap"
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["indicator-card 123", { selected: _ctx.selectedSell && _ctx.selectedSell.factorCode === factor.factorCode }]),
                      style: _normalizeStyle(_ctx.selectedSell && _ctx.selectedSell.factorCode === factor.factorCode ? {} : { background: _ctx.isLight ? '#f0f2f5' : _ctx.colors.bgActionBtn }),
                      onClick: ($event: any) => (_ctx.openSellPopover(factor))
                    }, [
                      _withDirectives((_openBlock(), _createElementBlock("div", {
                        class: "indicator-name",
                        style: _normalizeStyle(_ctx.selectedSell && _ctx.selectedSell.factorCode === factor.factorCode ? { color: '#000' } : { color: _ctx.colors.textPrimary })
                      }, [
                        _createTextVNode(_toDisplayString(factor.factorName), 1)
                      ], 4)), [
                        [_directive_widthoverflowtitle, factor.factorName]
                      ]),
                      _withDirectives((_openBlock(), _createElementBlock("div", {
                        class: "indicator-type",
                        style: _normalizeStyle(_ctx.selectedSell && _ctx.selectedSell.factorCode === factor.factorCode ? { color: '#fe4043' } : { color: _ctx.colors.textSecondary })
                      }, [
                        _createTextVNode(_toDisplayString(factor.factorDescript), 1)
                      ], 4)), [
                        [_directive_widthoverflowtitle, factor.factorDescript]
                      ]),
                      (_ctx.selectedSell && _ctx.selectedSell.factorCode === factor.factorCode)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "close-btn",
                            onClick: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clearSell && _ctx.clearSell(...args)), ["stop"]))
                          }, [
                            _createElementVNode("img", {
                              src: _ctx.closeIcon,
                              alt: "关闭"
                            }, null, 8, _hoisted_43)
                          ]))
                        : _createCommentVNode("", true)
                    ], 14, _hoisted_42),
                    (_ctx.sellPopover === factor.factorCode)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                          _createElementVNode("div", _hoisted_45, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(factor.options, (opt) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: opt.optionCode,
                                class: _normalizeClass(["option-item", { 'option-item--active': _ctx.pendingSellOption && _ctx.pendingSellOption.opt.optionCode === opt.optionCode }]),
                                onClick: ($event: any) => (_ctx.pendingSellOption = { factor, opt })
                              }, _toDisplayString(opt.optionName), 11, _hoisted_46))
                            }), 128))
                          ]),
                          _createElementVNode("div", _hoisted_47, [
                            _hoisted_48,
                            _createElementVNode("button", {
                              class: _normalizeClass(["option-confirm-btn", { 'option-confirm-btn--disabled': !_ctx.pendingSellOption }]),
                              disabled: !_ctx.pendingSellOption,
                              onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.confirmSellOption && _ctx.confirmSellOption(...args)))
                            }, "确定", 10, _hoisted_49)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ], 4),
            _createElementVNode("div", {
              class: "step-section",
              style: _normalizeStyle({ background: _ctx.isLight ? '#ffffff' : _ctx.colors.bgCard })
            }, [
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("h2", {
                    class: "step-title",
                    style: _normalizeStyle({ color: _ctx.colors.textPrimary })
                  }, "第四步：回测周期", 4),
                  _createElementVNode("div", _hoisted_52, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.periodList, (period) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: period.code,
                        class: _normalizeClass(["period-option", { selected: _ctx.selectedPeriod === period.code }]),
                        style: _normalizeStyle(_ctx.selectedPeriod === period.code ? {} : { background: _ctx.isLight ? '#f0f2f5' : _ctx.colors.bgActionBtn, color: _ctx.colors.textPrimary }),
                        onClick: ($event: any) => (_ctx.selectPeriod(period.code))
                      }, [
                        _createTextVNode(_toDisplayString(period.name) + " ", 1),
                        (_ctx.selectedPeriod === period.code)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "close-btn",
                              onClick: _withModifiers(($event: any) => (_ctx.selectPeriod(period.code)), ["stop"])
                            }, [
                              _createElementVNode("img", {
                                src: _ctx.closeIcon,
                                alt: "关闭"
                              }, null, 8, _hoisted_55)
                            ], 8, _hoisted_54))
                          : _createCommentVNode("", true)
                      ], 14, _hoisted_53))
                    }), 128)),
                    _createElementVNode("div", {
                      class: _normalizeClass(["period-option custom-period-option", { selected: _ctx.selectedPeriod === 'custom' }]),
                      style: _normalizeStyle(_ctx.selectedPeriod === 'custom' ? {} : { background: _ctx.isLight ? '#f0f2f5' : _ctx.colors.bgActionBtn, color: _ctx.colors.textPrimary }),
                      onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.selectedPeriod !== 'custom' && _ctx.selectPeriod('custom')))
                    }, [
                      _hoisted_56,
                      _createElementVNode("div", {
                        onClick: _cache[13] || (_cache[13] = _withModifiers(() => {}, ["stop"]))
                      }, [
                        _createVNode(_component_a_range_picker, {
                          value: _ctx.customDateRange,
                          "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.customDateRange) = $event)),
                          "disabled-date": (d) => {
                      if (!d) return false
                      const now = Date.now()
                      const twoYearsAgo = now - 2 * 365 * 24 * 60 * 60 * 1000
                      return d.valueOf() > now || d.valueOf() < twoYearsAgo
                    },
                          format: "YYYY-MM-DD",
                          class: "custom-range-picker",
                          onChange: _ctx.onCustomDateChange
                        }, null, 8, ["value", "disabled-date", "onChange"])
                      ]),
                      (_ctx.selectedPeriod === 'custom')
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "close-btn",
                            onClick: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (_ctx.selectPeriod('custom')), ["stop"]))
                          }, [
                            _createElementVNode("img", {
                              src: _ctx.closeIcon,
                              alt: "关闭"
                            }, null, 8, _hoisted_57)
                          ]))
                        : _createCommentVNode("", true)
                    ], 6)
                  ])
                ])
              ])
            ], 4)
          ])
        ]),
        _createElementVNode("div", {
          class: "bottom-section",
          style: _normalizeStyle({ background: _ctx.isLight ? '#ffffff' : _ctx.colors.bgCard })
        }, [
          _createElementVNode("div", _hoisted_58, [
            _createElementVNode("h3", {
              class: "summary-title",
              style: _normalizeStyle({ color: _ctx.colors.textPrimary })
            }, "策略摘要", 4),
            _createElementVNode("div", {
              class: "summary-content",
              style: _normalizeStyle({ color: _ctx.colors.textSecondary })
            }, [
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("span", _hoisted_60, [
                  _hoisted_61,
                  _createElementVNode("strong", {
                    style: _normalizeStyle({ color: _ctx.colors.textPrimary })
                  }, _toDisplayString(_ctx.summaryStock), 5)
                ]),
                _createElementVNode("span", _hoisted_62, [
                  _hoisted_63,
                  _createElementVNode("span", _hoisted_64, _toDisplayString(_ctx.summaryBuy), 1)
                ]),
                _createElementVNode("span", _hoisted_65, [
                  _hoisted_66,
                  _createElementVNode("span", _hoisted_67, _toDisplayString(_ctx.summarySell), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_68, [
                _createElementVNode("span", _hoisted_69, [
                  _hoisted_70,
                  _createElementVNode("strong", {
                    style: _normalizeStyle({ color: _ctx.colors.textPrimary })
                  }, _toDisplayString(_ctx.summaryPeriod), 5)
                ])
              ])
            ], 4)
          ]),
          _createElementVNode("button", {
            class: "backtest-btn",
            onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.goResult && _ctx.goResult(...args)))
          }, "一键回测")
        ], 4)
      ], 4),
      (_ctx.globalLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
            _createVNode(_component_a_spin, {
              tip: "回测中，请稍候...",
              size: "large"
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}